define('app-Forms/main',["./settings", "../app-Gdpr/main"], function (settings, gdpr) {
    return {
        checkGdprCriteria: function (callback) {
            var fields = {
                firstName: settings.firstName.val(),
                surname: settings.lastName.val(),
                address1: settings.address1.val(),
                postcode: settings.postcode.val(),
                email: settings.emailAddress.val(),
                //DOB Always set by default in forms to 01/01/1960 so will never be missing
                day: settings.day.val(),
                month: settings.month.val(),
                year: settings.year.val()
            };

            var missingCriteria = [];

            $.each(fields, function (index, value) {
                if (!value || value.length === 0) {
                    missingCriteria.push(index);
                }
            });

            if (missingCriteria.length === 0) {
                callback();
            }
        },

        getCustomerData: function () {
            var getGender = function (title) {
                var x = title.toLowerCase();

                switch (x) {
                    case "mr":
                        return "Male";
                    case "mrs":
                        return "Female";
                    case "ms":
                        return "Female";
                    case "miss":
                        return "Female";
                    default:
                        return "";
                }
            }

            var cleanseData = function (string) {
                return string.replace(/['"*#_\[\]{}|()]/g, "");
            }

            var firstName = cleanseData(settings.firstName.val()),
                lastName = cleanseData(settings.lastName.val());

            firstName = firstName.replace(firstName.charAt(0), firstName.charAt(0).toUpperCase());
            lastName = lastName.replace(lastName.charAt(0), lastName.charAt(0).toUpperCase());

            var day = settings.day.val(),
                month = settings.month.val(),
                year = settings.year.val();

            return {
                Title: settings.title.val(),
                FirstName: firstName,
                MiddleName: "",
                LastName: lastName,
                Address: {
                    HouseNo: settings.address1.val(),
                    Street: "",
                    Town: settings.town.val(),
                    County: settings.county.val(),
                    PostCode: settings.postcode.val(),
                    Uprn: settings.uprn.val(),
                    Udprn: settings.udprn.val()
                },
                DateOfBirth: day + "/" + month + "/" + year + " 00:00:00",
                EmailAddress: settings.emailAddress.val(),
                EmailUsableByMarketing: false,
                Gender: getGender(settings.title.val()),
                HasMiddleName: false,
                HasMobileNumber: settings.mobileAltNumber.length > 0 && settings.mobileAltNumber.val().length > 0,
                MobileNo: settings.mobileAltNumber.length > 0 ? settings.mobileAltNumber.val() : "",
                Passport: "",
                TelephoneNo: settings.telephoneNumber.length > 0 ? settings.telephoneNumber.val() : ""
            }
        },

        run: function () {
            var self = this;
            var container = $(settings.container);
            if (container.length <= 0) return;

            var gdprContainer = container.find("#gdpr-content-container");
            if (gdprContainer.length <= 0) return;

            var brochureForm = container.find("form"),
                gdprProduct = container.find("#gdprProduct").val(),
                journey = container.find("#gdprJourney").val();

            settings.watchFields.on("change", function () {
                self.checkGdprCriteria(function () {
                    gdpr.display({
                        container: gdprContainer,
                        product: gdprProduct,
                        journey: journey,
                        person: self.getCustomerData(),
                        continueButton: brochureForm.find("button[type='submit']"),
                        reportValidation: true,
                        continueCallback: function () {
                            brochureForm.submit();
                        }
                    });
                });
            });

            window.loadedModules("app-Forms");
        }
    };
});
